import type { FreehandElement } from '@/components/canvas/document/publicTypes';
import { firstStroke } from '@/components/canvas/elements/model';

export function drawFreehand(ctx: CanvasRenderingContext2D, el: FreehandElement) {
  const { x, y } = el.layout;
  const { width, height } = el.size;
  const { pathData } = el.data;
  const stroke = firstStroke(el.appearance);
  const strokeWidth = stroke?.width ?? 2;
  if (!pathData) return;

  const scaleX = width / 100;
  const scaleY = height / 100;

  ctx.save();
  ctx.translate(x, y);
  ctx.scale(scaleX, scaleY);

  const path = new Path2D(pathData);
  ctx.strokeStyle = stroke?.color ?? '#000';
  ctx.lineWidth = strokeWidth / Math.sqrt(scaleX * scaleY);
  ctx.lineCap = 'round';
  ctx.lineJoin = 'round';
  ctx.setLineDash([]);
  ctx.stroke(path);

  ctx.restore();
}
